import { z } from 'zod'

import { AiAutomationSchemas } from 'shared/api/requests/aiAutomation/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const AiAutomationSocketEventsSchemas = {
  automationUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_updated'),
    config: AiAutomationSchemas.config,
  }),

  tovSamplesGenerated: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_positive_reply_samples_generated'),
    samples: z.array(AiAutomationSchemas.tovSample),
  }),
}
